import React, { FC, useState, useEffect } from 'react';
import { Tabs, TabItem } from '@rubin-dev/goblin';
import { useTranslation } from 'react-i18next';
import { FinderTab } from './components/FinderTab';
import styles from './styles/markup.module.scss';
import { RequestsTab } from './components/RequestsTab';
import * as gqlTypes from '@apolloGenerated';
import { useSubscriptionListLazyQuery } from '@apolloGenerated';
import { useMeLazyQuery } from '@apolloGenerated';
import { useSubscriptionStore } from '@component/Mention';

enum TabsEnum {
  FINDER = 'finder',
  REQUESTS = 'requests',
}

export type PropsType = {
  user?: gqlTypes.User;
  state: {
    loading?: boolean;
  };
  query: {
    query: string;
  };
};
export const MarkupScreen: FC<PropsType> = ({
  query,
  user,
  state: { loading = false },
}) => {
  const { t } = useTranslation();

  const { isSubscribed } = useSubscriptionStore();

  const [fetchMe] = useMeLazyQuery({ fetchPolicy: 'network-only' });
  const [fetch, { data, refetch }] = useSubscriptionListLazyQuery();

  const [tab, setTab] = useState(TabsEnum.FINDER);

  useEffect(() => {
    fetch({
      variables: {
        page: 1,
        pageSize: 10,
      },
    });
  }, []);

  useEffect(() => {
    refetch({
      page: 1,
      pageSize: 10,
    });
  }, [isSubscribed]);

  const handleChangeTab = (val: TabsEnum) => {
    setTab(val);
  };

  return (
    <>
      <div className={styles['markup']}>
        <section className={styles['markup__section']}>
          <div className={styles['markup__tabs-wrapper']}>
            <Tabs onChange={handleChangeTab} className={styles['markup__tabs']}>
              <TabItem value={TabsEnum.FINDER} label={t('markup.finder')} />
              <TabItem
                value={TabsEnum.REQUESTS}
                label={`${t('markup.requests')} (${data?.subscriptionList.total || 0})`}
              />
            </Tabs>
          </div>
          <div className={styles['markup__content']}>
            {tab === TabsEnum.FINDER ? (
              <FinderTab
                query={query}
                user={user}
                loading={loading}
                onCheck={fetchMe}
                checkCount={user?.billing?.markup}
                onClick={() => handleChangeTab(TabsEnum.REQUESTS)}
              />
            ) : (
              <div className={styles['markup__container']}>
                <RequestsTab />
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};
